import axios from "axios";
import apiService from "../../services/apiService";

const REVIEW_API = process.env.REACT_APP_BACKEND_API;

export const getProductReviews = async (productId) => {
  try {
    const { data } = await axios.get(
      `${REVIEW_API}frontend/reviews`,
      {
        params: { product_id:  Number(productId) },
      }
    );

    if (data?.status) return data?.data;
    return [];
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch reviews"
    );
  }
};


export const postReview = async (payload) => {
  try {
    const formData = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (key === "product_id") {
          formData.append(key, Number(value));
        } else {
          formData.append(key, value);
        }
      }
    });

    const { data } = await apiService.create(
      `${REVIEW_API}backend/reviews`,
      formData
    );

    if (data?.status) return data;

    throw new Error(data?.message || "Failed to add review");
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
      error?.response?.data?.errors?.product_id?.[0] ||
      "Failed to add review"
    );
  }
};


export const updateReview = async ({ reviewId, payload }) => {
  try {
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append("_method", "PUT");

    const { data } = await apiService.create(
      `${REVIEW_API}backend/reviews/${reviewId}`,
      formData
    );

    if (data?.status) return data;
    throw new Error(data?.message);
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update review"
    );
  }
};
